
import PropTypes from 'prop-types'
import React from 'react'
import Copy from '../Copy'
import './run-event.css'

const RunEvent = props => {
  const { level, objectType, objectName, response, helpText } = props

  return (
    <div className='RunEvent' data-level={level}>
      <div className='RunEvent-header'>
        <div className='RunEvent-title'>
          <span className='RunEvent-category'>{objectType}</span>
          <span className='RunEvent-name'>{objectName}</span>
        </div>
      </div>
      <div className='RunEvent-response' hidden={!response}>
        {response}
      </div>
      <div className='RunEvent-helpText' hidden={!helpText}>
        <Copy size='tiny'>{helpText}</Copy>
      </div>
    </div>
  )
}

RunEvent.propTypes = {
  helpText: PropTypes.string.isRequired,
  level: PropTypes.string.isRequired,
  objectName: PropTypes.string.isRequired,
  objectType: PropTypes.string.isRequired,
  response: PropTypes.string.isRequired
}

RunEvent.displayName = 'RunEvent'

export default RunEvent



// WEBPACK FOOTER //
// ./ui/Run/run-event.js